import { FormatType } from "../../Alert/Filter/FilterType";
import {
  ConfigurationFormType,
  ConfigurationPageTables,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";

const SURQUAL_FARE_CODE_PAGE_FARE_CODE_GROUP2_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  path: "groups-2",
  label: "FARE_CODE_GROUP_2",
  separator: true,
  model: {
    entityName: "short_name",
    label: "FARE_CODE_GROUP_2",
    path: "/api/fare-codes-groups-2",
    name: "fare_codes_groups_2",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/fare-codes-groups-2/export" },
    import: { path: "/api/fare-codes-groups-2/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
    ],
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
    ],
    deletable: true,
  },
};

const SURQUAL_FARE_CODE_PAGE_FARE_CODE_GROUP1_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "FARE_CODE_GROUP_1",
  path: "groups-1",
  model: {
    entityName: "short_name",
    label: "FARE_CODE_GROUP_1",
    path: "/api/fare-codes-groups-1",
    name: "fare_code_group1",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        key: "group2.short_name",
        order: 4,
        label: "FARE_CODE_GROUP_2",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/fare-codes-groups-1/export" },
    import: { path: "/api/fare-codes-groups-1/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/fare-codes-groups-2/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "group2",
        label: "FARE_CODE_GROUP_2",
        labelKey: "short_name",
        subCreationForm: SURQUAL_FARE_CODE_PAGE_FARE_CODE_GROUP2_TAB,
      },
      {
        key: "separatorQualification",
        label: "QUALIFICATION",
        type: ConfigurationFormType.Separator,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "group2",
        flex: "50%",
      },
    ],
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "group2",
        flex: "50%",
      },
    ],
    deletable: true,
  },
};

const SURQUAL_FARE_CODE_PAGE_FARE_CODE_NANDC: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "RATE_CODE_NC",
  path: "",
  separator: true,
  model: {
    entityName: "short_name",
    label: "RATE_CODE_NC",
    path: "/api/fare-codes-nandc",
    name: "Code Tarifaire NandC",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        key: "group.short_name",
        order: 4,
        label: "GROUP",
        visible: true,
      },
      {
        key: "exclude_from_model",
        order: 9,
        label: "EXCLUDE_FROM_MODEL",
        visible: true,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: { color: "text.cell" },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: { color: "text.accent" },
          },
        ],
        type: FormatType.BOOLEAN,
      },
      {
        key: "zero_nb_uh",
        order: 10,
        label: "ZERO_NB_UH_IN_AGGREGATS",
        visible: true,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: { color: "text.cell" },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: { color: "warning.main" },
          },
        ],
        type: FormatType.BOOLEAN,
      },
      {
        key: "zero_revenue",
        order: 11,
        label: "ZERO_REVENUE_IN_AGGREGATS",
        visible: true,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: { color: "text.cell" },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: { color: "warning.main" },
          },
        ],
        type: FormatType.BOOLEAN,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/fare-codes/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/fare-codes-nandc/export" },
    import: { path: "/api/fare-codes-nandc/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "group",
        label: "GROUP",
        type: ConfigurationFormType.Select,
        api: "/api/fare-codes-nandc-group/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        labelKey: "short_name",
      },
      {
        key: "separatorQualification",
        label: "QUALIFICATION",
        type: ConfigurationFormType.Separator,
      },
      {
        key: "exclude_from_model",
        label: "EXCLUDE_FROM_MODEL",
        type: ConfigurationFormType.Check,
      },
      {
        key: "zero_nb_uh",
        label: "ZERO_NB_UH_IN_AGGREGATS",
        type: ConfigurationFormType.Check,
      },
      {
        key: "zero_revenue",
        label: "ZERO_REVENUE_IN_AGGREGATS",
        type: ConfigurationFormType.Check,
      },
    ],
    creatable: false,
    copyable: false,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        readonly: true,
      },
      {
        key: "short_name",
        flex: "50%",
        readonly: true,
      },
      {
        key: "name",
        flex: "100%",
        readonly: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "group",
        flex: "100%",
        required: true,
      },
      {
        key: "exclude_from_model",
        flex: "50%",
      },
      {
        key: "zero_nb_uh",
        flex: "50%",
      },
      {
        key: "zero_revenue",
        flex: "50%",
      },
    ],
    deletable: false,
  },
};

const SURQUAL_FARE_CODE_PAGE_FARE_CLASS_PARENT_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "YIELD_CLASS_PARENT",
  path: "fare-classes-parents",
  model: {
    entityName: "short_name",
    label: "YIELD_CLASS_PARENT",
    path: "/api/fare-classes-parents",
    bulkPath: "/api/fare-classes-parents/bulk-updates",
    name: "Classe Tarifaire Meres",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        align: "right",
        key: "weight",
        order: 3,
        label: "WEIGHT",
        visible: true,
      },
      {
        align: "right",
        key: "quota_min",
        order: 4,
        label: "QUOTA_MIN",
        visible: true,
      },
      {
        align: "right",
        key: "order",
        order: 5,
        label: "RANK",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/fare-classes-parents/export" },
    import: { path: "/api/fare-classes-parents/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        inputType: "number",
        key: "weight",
        label: "WEIGHT",
        type: ConfigurationFormType.Input,
      },
      {
        inputType: "integer",
        key: "quota_min",
        label: "QUOTA_MIN",
        type: ConfigurationFormType.Input,
      },
      {
        inputType: "integer",
        key: "order",
        label: "RANK",
        type: ConfigurationFormType.Input,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "weight",
        flex: "100%",
        required: true,
      },
      {
        key: "quota_min",
        flex: "100%",
        required: true,
      },
      {
        key: "order",
        flex: "50%",
        required: true,
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "weight",
        flex: "100%",
        required: true,
      },
      {
        key: "quota_min",
        flex: "100%",
        required: true,
      },
      {
        key: "order",
        flex: "50%",
        required: true,
      },
    ],
    rankable: {
      column: "order",
    },
  },
};

const SURQUAL_FARE_CODE_PAGE_FARE_CLASS_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "YIELD_CLASS",
  path: "fare-classes",
  model: {
    entityName: "short_name",
    label: "YIELD_CLASS",
    path: "/api/fare-classes",
    bulkPath: "/api/fare-classes/bulk-updates",
    name: "Classe Tarifaire",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        align: "right",
        key: "order",
        order: 4,
        label: "RANK",
        visible: true,
      },
      {
        key: "parent.short_name",
        order: 5,
        label: "YIELD_CLASS_PARENT",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/fare-classes/export" },
    import: { path: "/api/fare-classes/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        inputType: "integer",
        key: "order",
        label: "RANK",
        type: ConfigurationFormType.Input,
      },
      {
        api: "/api/fare-classes-parents/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "parent",
        label: "YIELD_CLASS_PARENT",
        labelKey: "short_name",
        type: ConfigurationFormType.Select,
        subCreationForm: SURQUAL_FARE_CODE_PAGE_FARE_CLASS_PARENT_TAB,
      },
      {
        key: "separatorQualification",
        label: "QUALIFICATION",
        type: ConfigurationFormType.Separator,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "order",
        flex: "50%",
      },
      {
        key: "parent",
        flex: "50%",
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "order",
        flex: "50%",
      },
      {
        key: "parent",
        flex: "50%",
      },
    ],
    rankable: {
      column: "order",
    },
  },
};

const SURQUAL_FARE_CODE_PAGE_FARE_CODE_TAB: ConfigurationPageTables = {
  description: "CONF_DESC_SELFMAPPING_RATE_CODE",
  type: ConfigurationPageType.TABLE,
  label: "RATE_CODE",
  path: "test",
  separator: true,
  model: {
    entityName: "short_name",
    label: "RATE_CODE",
    path: "/api/fare-codes",
    bulkPath: "/api/fare-codes/bulk-updates",
    name: "Code Tarifaire",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        key: "properties",
        order: 4,
        label: "PROPERTIES",
        sortable: false,
        type: FormatType.LIST,
        labelKey: "short_name",
        numberOfColumnItemsToDisplay: 2,
        tooltip: true,
        visible: true,
      },
      {
        key: "nb_uh_r12",
        className: "progressOcc",
        order: 5,
        label: "OCC_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS,
        visible: true,
      },
      {
        key: "turnover_r12",
        className: "progressCA",
        order: 6,
        label: "CA_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "pm_r12",
        className: "progressPM",
        order: 7,
        label: "PM_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "fare_class.short_name",
        order: 8,
        label: "YIELD_CLASS",
        visible: true,
      },
      {
        key: "group1.short_name",
        order: 9,
        label: "FARE_CODE_GROUP_1",
        visible: true,
      },
      {
        key: "fare_code_nandc.short_name",
        order: 10,
        label: "RATE_CODE_NC",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/fare-codes/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.SelectMultiple,
        mustTranslateOptions: false,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "properties",
        labelKey: "hebergement_nom_court",
        label: "PROPERTIES",
        lookup: "property__in",
        controlledInputSize: true,
        numericIds: true,
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/fare-codes/export" },
    import: { path: "/api/fare-codes/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/fare-classes/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "fare_class",
        label: "YIELD_CLASS",
        labelKey: "short_name",
        subCreationForm: SURQUAL_FARE_CODE_PAGE_FARE_CLASS_TAB,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/fare-codes-groups-1/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "group1",
        label: "FARE_CODE_GROUP_1",
        labelKey: "short_name",
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/fare-codes-nandc/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "fare_code_nandc",
        label: "RATE_CODE_NC",
        labelKey: "short_name",
      },
      {
        key: "separatorQualification",
        label: "QUALIFICATION",
        type: ConfigurationFormType.Separator,
      },
    ],
    copyable: false,
    copyOptions: [],
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "group1",
        flex: "50%",
      },
      {
        key: "fare_code_nandc",
        flex: "50%",
      },
      {
        key: "fare_class",
        flex: "50%",
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "group1",
        flex: "50%",
      },
      {
        key: "fare_code_nandc",
        flex: "50%",
      },
      {
        key: "fare_class",
        flex: "50%",
      },
    ],
    editSelectedOptions: [
      {
        key: "fare_code_nandc",
        flex: "50%",
      },
      {
        key: "fare_class",
        flex: "50%",
      },
      {
        key: "group1",
        flex: "50%",
      },
    ],
  },
};

export const SURQUAL_FARE_CODE_PAGE = {
  type: ConfigurationPageType.TABS,
  count: 0,
  description: "CONF_PAGE_DESC_DEFAULT",
  label: "RATE_CODE",
  pageLabel: "RATE_CODE_TITLE_SURQUAL",
  menuLabel: "RATE_CODE",
  path: "code-tarifaire",
  name: "fare_code",
  tabs: [
    SURQUAL_FARE_CODE_PAGE_FARE_CODE_TAB,
    SURQUAL_FARE_CODE_PAGE_FARE_CODE_GROUP1_TAB,
    SURQUAL_FARE_CODE_PAGE_FARE_CODE_GROUP2_TAB,
    SURQUAL_FARE_CODE_PAGE_FARE_CODE_NANDC,
    SURQUAL_FARE_CODE_PAGE_FARE_CLASS_TAB,
    SURQUAL_FARE_CODE_PAGE_FARE_CLASS_PARENT_TAB,
  ],
};
